export default __webpack_public_path__ + "assets/291825a2198b5c1f31c4a561825d7ba9.png";